import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e07ae91&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2e07ae91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e07ae91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e07ae91')) {
      api.createRecord('2e07ae91', component.options)
    } else {
      api.reload('2e07ae91', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e07ae91&scoped=true&", function () {
      api.rerender('2e07ae91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/room_stat/index.vue"
export default component.exports